{
  "en": {
    "issue_status": {
      "actions": {
        "create": "Create Snagging Status"
      },
      "labels": {
        "backup_status": "Replacement status",
        "customer_status": "Customer will see",
        "delete_status": "Delete status \"{name}\"?",
        "delete_status_disclaimer": "All aftercare items with this status will be reassigned to the status you select below.",
        "inbox_hint": "Default inbox status",
        "internal_status": "Internal status",
        "new_issue_status": "Status"
      }
    }
  }
}
